export const TITLE = "transform your cat’s life with fresh food";
export const SUBTITLE = "7 vet-formulated recipes. Fussy cat-approved. For bowls licked clean.";
